<div id="orders" class="page-layout carded fullwidth ">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'DRIVE_LOG_LIST' | translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div class="row"></div>
        </div>
        <!-- / HEADER -->

        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="startDate"
                    matSortDirection="desc" fusePerfectScrollbar>

                    <ng-container matColumnDef="polygon">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                        <span class="mr-8">{{'REGION'|translate}}</span>
                        <mat-icon matTooltip="Bölgenin Adı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.polygon!=null?(driverProcess.polygon!=null?driverProcess.polygon.name:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="treshold">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'CONTAINER_COLLECTION_THRESHOLD'|translate}}</span>
                            <mat-icon matTooltip="Bölgenin toplama eşik değeri">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.polygon!=null?(driverProcess.polygon!=null?driverProcess.polygon.treshold:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="driver_name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'DRIVER_NAME'|translate}}</span>
                            <mat-icon matTooltip="Sürücünün adı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.sessionLog!=null?(driverProcess.sessionLog.user.name!=null?(driverProcess.sessionLog.user.name):'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="plate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'PLATE'|translate}}</span>
                            <mat-icon matTooltip="Aracın plakası">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.car!=null?(driverProcess.car.plate!=null?driverProcess.car.plate:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="allContainerCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'ALL_CONTAINER_COUNT'|translate}}</span>
                            <mat-icon matTooltip="Toplam konteyner sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.allContainerCount!=null?driverProcess.allContainerCount:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="fullContainerCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'FULL_CONTAINER_COUNT'|translate}}</span>
                            <mat-icon matTooltip="Bölgenin toplama eşiğini aşan konteyner sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.fullContainerCount!=null?driverProcess.fullContainerCount:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="emptyContainerCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'EMPTY_CONTAINER_COUNT'|translate}}</span>
                            <mat-icon matTooltip="Bölgenin toplama eşiğinin altında kalan konteyner sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.emptyContainerCount!=null?driverProcess.emptyContainerCount:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="estimatedDistance">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'ESTIMATED_DISTANCE'|translate}}</span>
                            <mat-icon matTooltip="Rotayı tahmini dolaşma kilometresi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.estimatedDistance!=null?(driverProcess.estimatedDistance/1000)+' km':'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="estimatedTime">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'ESTIMATED_TIME'|translate}}</span>
                            <mat-icon matTooltip="Rotayı tahmini dolaşma süresi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.estimatedTime!=null?((driverProcess.estimatedTime)| dayHourMinute):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'SHIFT_DESCRIPTION'|translate}}</span>
                            <mat-icon matTooltip="Açıklaması">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.shift!=null?driverProcess.shift.description:"---"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="profitability">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'PROFITABILITY'|translate}}</span>
                            <mat-icon matTooltip="Toplam konteynerin dolu konteynerlere oranı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.driverProcessDetails.length>0 ? ((100 - ((100 * driverProcess.driverProcessDetails.length)/driverProcess.allContainerCount)) | number : '1.0-2'):'0'}}%
                        </mat-cell>
                    </ng-container>
           
                    <ng-container matColumnDef="distanceTraveled">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'DISTANCE_TRAVELED'|translate}}</span>
                            <mat-icon matTooltip="Toplam dolaştığı kilometre">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.distanceTraveled!=null?(driverProcess.distanceTraveled/1000)+' km':"---"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="startDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'START_DATE'|translate}}</span>
                            <mat-icon matTooltip="Rotaya başlangıç zamanı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.startDate!=null?(driverProcess.startDate | date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>
             
                    <ng-container matColumnDef="startLocation">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'START_LOCATION'|translate}}</span>
                            <mat-icon matTooltip="Rotaya başlangıç konumu">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                        <a *ngIf="driverProcess.startLat" matTooltip="{{driverProcess.startLat+'/'+driverProcess.startLng}}"
                            href="javascript:void(null)" (click)="onDriverProcessStartMap(driverProcess)">
                            <mat-icon>map</mat-icon>
                        </a>
                        <span *ngIf="!driverProcess.startLat">---</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="endDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'END_DATE'|translate}}</span>
                            <mat-icon matTooltip="Rota bitiş zamanı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            {{driverProcess.endDate!=null?(driverProcess.endDate |date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="endLocation">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'END_LOCATION'|translate}}</span>
                            <mat-icon matTooltip="Rota bitiş konumu">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                        <a *ngIf="driverProcess.endLat" matTooltip="{{driverProcess.endLat+'/'+driverProcess.endLng}}"
                            href="javascript:void(null)" (click)="onDriverProcessEndMap(driverProcess)">
                            <mat-icon>map</mat-icon>
                        </a>
                        <span *ngIf="!driverProcess.endLat">---</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let driverProcess">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="driverProcessDetail(driverProcess)">
                                    <mat-icon>info</mat-icon>
                                    <span>{{'DETAIL'|translate}}</span>
                                </button>
                                <!-- <button mat-menu-item (click)="routeHistory(driverProcess)">
                                    <mat-icon>map</mat-icon>
                                    <span>{{'LOCATION'|translate}}</span>
                                </button> -->
                                <button mat-menu-item (click)="deleteProcessDelete(driverProcess)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let shift columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>